
import { defineComponent } from 'vue';

import { SocialProfile } from '@/models/Social/social-profile';
import PrzPromoCoupon from '@/components/Blocks/Singles/Parts/PromoCoupon/Component.vue';
import { DeviceType } from "@/models/Blocks/Itens/Types/device-type";
import PrzSingleBlock from '@/components/Blocks/Block/Single.vue';
import PrzSocialCampaign from '@/components/Social/Campaign/Desktop.vue';
import CopyToClipboard from "@/components/Muffin/CopyToClipboard.vue";
import Counter from "@/components/Muffin/Counter.vue";
import {isEmpty} from "lodash-es";
export default defineComponent({
    components: {
        Counter, CopyToClipboard,
        PrzPromoCoupon,
        PrzSingleBlock,
        PrzSocialCampaign
    },
    filters: {
        strippedContent: function(string) {
            return string ? string.replace(/<\/?[^>]+>/ig, " ") : '';
        }
    },
    props:{
        campaigns: {
            type: Array,
            default: null
        },
        clubMode: {
            type: Boolean,
            default: false
        },
        couponsRaw: {
            type: Array | null,
            default: null
        },
        followers: {
            type: [String, Number],
            default: ''
        },
        kStrings:{
            type: Object,
            default: () => {
                return {
                    following: 'Following',
                    follow: 'Follow',
                    copied: 'Copied',
                }
            }
        },
        profile:{
            type: SocialProfile,
            default: () => new SocialProfile()
        }
    },
    data() {
        return {
            showCopyMsg: false
        }
    },
    computed:{
        buttonText(){
            return this.profile && this.profile.following ? this.kStrings.following : this.kStrings.follow;
        },
        /*couponCode():string|undefined{
            return this.profile.couponCode;
        },*/
        device():DeviceType{
            return DeviceType.desktop;
        },
        rawDefaultCoupon() {
            return !isEmpty(this.couponsRaw) ? this.couponsRaw[0] : null;
        }
    },
    mounted(){},
    methods:{
        async copyPageLink() {
            try {
                await navigator.clipboard.writeText(this.profile.shareOtLink ? this.profile.shareOtLink : location.href);
                this.showCopyMsg = true;
                setTimeout(() => {
                    this.showCopyMsg = false;
                }, 3000);
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        },
        async followClick(){
            await this.profile.like.click();
        },
        onClose(){
            this.showModal = false;
            this.$emit('close');
            document.body.style.removeProperty('overflow-y');
        },
        openModal(campaignIdSelected) {
            this.showModal = true;
            document.body.style.overflowY = "hidden";
            setTimeout(() => {
                if(campaignIdSelected) {
                    const headerHeight = (document.querySelector('.promoter-header-box') as HTMLDivElement)?.offsetHeight * 2;
                    const element = document.getElementById(campaignIdSelected);
                    const y = element.getBoundingClientRect().top  + -headerHeight;

                    document.getElementById('scroll-list').scrollTo({
                        top: y,
                        behavior: 'smooth'
                    });
                }
            }, 500) ;
        },
    }
});
